module.exports = "https://p.cds.unp.clasificados.pe/logo-gec.c848ac5808781dc1fceee5d6aae0d887.svg";